module.exports = __webpack_public_path__ + "img/GY.e92264b1.png";